import React from "react";
import { ToastContainer, toast } from "react-toastify";

export const showToast = (message, options = {}) => toast(message, options);

export const showErrorToast = (message, options = {}) =>
  toast.error(message, options);

export const showSuccessToast = (message, options = {}) =>
  toast.success(message, options);

export const Toast = ({
  position = "top-right",
  autoClose = 3000,
  ...props
}) => (
  <ToastContainer
    position={position}
    autoClose={autoClose}
    newestOnTop
    closeOnClick
    pauseOnHover
    limit={3}
    {...props}
  />
);

export default Toast;
